"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _reactFinalFormArrays = require("react-final-form-arrays");
var _components = require("@folio/stripes/components");
var _CustomPropertiesFilterField = _interopRequireDefault(require("./CustomPropertiesFilterField"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomPropertiesFilterFieldArray = _ref => {
  let {
    customProperties,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {}
  } = _ref;
  const {
    mutators: {
      push
    }
  } = (0, _reactFinalForm.useForm)();
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalFormArrays.FieldArray, {
      name: "filters",
      children: _ref2 => {
        let {
          fields
        } = _ref2;
        return fields.map((name, index) => {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Card, {
              headerEnd: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Tooltip, {
                id: `custom-property-filter-card-delete-[${index}]-tooltip`,
                text: kintIntl.formatKintMessage({
                  id: 'customProperty.removeFilter',
                  overrideValue: labelOverrides.removeFilter
                }, {
                  index: index + 1
                }),
                children: _ref3 => {
                  let {
                    ref,
                    ariaIds
                  } = _ref3;
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
                    ref: ref,
                    "aria-labelledby": ariaIds.text,
                    icon: "trash",
                    id: `custom-property-filter-card-delete-[${index}]`,
                    onClick: () => fields.remove(index)
                  });
                }
              }),
              headerStart: /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                children: kintIntl.formatKintMessage({
                  id: 'customProperty.filterIndex',
                  overrideValue: labelOverrides.customPropertyFilter
                }, {
                  index: index + 1
                })
              }),
              marginBottom0: index !== fields.length - 1,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertiesFilterField.default, {
                customProperties: customProperties,
                fields: fields,
                index: index,
                labelOverrides: labelOverrides,
                name: name
              }, `custom-property-filter-field-${name}[${index}]`)
            }, `custom-property-filter-card[${index}]`), index < fields.value.length - 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Layout, {
              className: "textCentered",
              children: kintIntl.formatKintMessage({
                id: 'AND',
                overrideValue: labelOverrides.AND
              })
            }, `custom-property-filter[${index}]-AND`)]
          }, `custom-property-filter-card[${index}]-container`);
        });
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      onClick: () => push('filters', {
        rules: [{}]
      }),
      children: kintIntl.formatKintMessage({
        id: 'customProperty.addFilter',
        overrideValue: labelOverrides.addFilter
      })
    })]
  });
};
CustomPropertiesFilterFieldArray.propTypes = {
  customProperties: _propTypes.default.arrayOf(_propTypes.default.object),
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object
};
var _default = exports.default = CustomPropertiesFilterFieldArray;